/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InstallmentInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InstallmentInfo({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/InstallmentInfo"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let infoLhsValueData = fromData.useDataValue({ viewPath,
context: 'info',
path: 'lhs',
})
let infoRhsValueData = fromData.useDataValue({ viewPath,
context: 'info',
path: 'rhs',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
  return (<React.Fragment
>
<div
  data-testid="InstallmentInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-WXj4D': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="You will pay"
/>
<div
  data-testid="InstallmentInfo.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="info.lhs"
 text={infoLhsValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 marginLeft={dtSpaceXxxs}
 color={dtColorsBrandGreen}
 data="info.rhs"
 text={infoRhsValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}